import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import cn from 'classnames'

import WheelLoading from 'components/loading/wheel_loading'

import styles from './Pair.scss'

class Pair extends PureComponent {

	constructor() {
		super()
		this.generateElement = this.generateElement.bind(this)
		this.editPairHandler = this.editPairHandler.bind(this)
		this.selectPairHandler = this.selectPairHandler.bind(this)
	}

	selectPairHandler() {
		this.props.selectPairHandler(this.props.id)
	}

	editPairHandler() {
		this.props.editPairHandler(this.props.id)
	}

	generateElement(card) {
		if (this.props[card].type === 'image') {
			if (this.props[card].value) {
				return (
					<div styleName='image-tile'>
						<img
							styleName='image-tile-image'
							src={this.props[card].value}
						/>
					</div>
				)
			} else {
				return (
					<div styleName='image-loading'>
						<div styleName='image-loading-wheel'>
							<WheelLoading />
						</div>
					</div>
				)
			}
		} else {
			return (
				<div styleName='text-tile'>
					<p styleName='text-tile-text'>
						{this.props[card].value}
					</p>
				</div>
			)
		}
	}

	render() {
		return (
			<div styleName='pair-wrapper'>
				<div
					onClick={this.selectPairHandler}
					styleName={
						cn({
							pair: true,
							// 'pair--highlighted': true
							'pair--no-hover': this.props.noHover,
						})}
				>
					{ this.generateElement('card1') }
					{ this.generateElement('card2') }
				</div>
			</div>
		)
	}
}

Pair.propTypes = {
	items: PropTypes.object,
	selectPairHandler: PropTypes.func,
	noHover: PropTypes.bool,
}

Pair.defaultProps = {
	selectPairHandler: () => {},
	noHover: false,
}

export default CSSModules(Pair, styles, { allowMultiple: true })
